var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.853,
    height: 22.72,
    viewBox: "0 0 22.853 22.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_118",
    "data-name": "Trac\\xE9 118",
    d: "M24.242,37.569a1.3,1.3,0,0,1-1.371,1.169A1.273,1.273,0,0,1,21.5,37.569,1.3,1.3,0,0,1,22.871,36.4,1.273,1.273,0,0,1,24.242,37.569Z",
    transform: "translate(-17.715 -26.921)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_119",
    "data-name": "Trac\\xE9 119",
    d: "M33.042,26.678A1.371,1.371,0,1,1,31.671,25.3,1.387,1.387,0,0,1,33.042,26.678Z",
    transform: "translate(-22.859 -20.456)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_120",
    "data-name": "Trac\\xE9 120",
    d: "M46.442,26.678A1.371,1.371,0,1,1,45.071,25.3,1.387,1.387,0,0,1,46.442,26.678Z",
    transform: "translate(-30.693 -20.456)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_121",
    "data-name": "Trac\\xE9 121",
    d: "M54.726,37.569A1.163,1.163,0,1,1,53.563,36.4,1.139,1.139,0,0,1,54.726,37.569Z",
    transform: "translate(-35.778 -26.921)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_122",
    "data-name": "Trac\\xE9 122",
    d: "M23.943,13.7h-.415a11.382,11.382,0,0,0-7.686,19.542A11.126,11.126,0,0,0,23.9,36.416h0a2.506,2.506,0,0,0,2.493-2.505,2.668,2.668,0,0,0-.623-1.67,1.027,1.027,0,0,1-.249-.668,1.041,1.041,0,0,1,1.039-1.086h2.077a6.613,6.613,0,0,0,6.605-6.639C35.243,18.293,30.175,13.7,23.943,13.7Zm8.35,13.863a5.174,5.174,0,0,1-3.656,1.5H26.561a2.424,2.424,0,0,0-1.662.626,2.5,2.5,0,0,0-.831,1.712,2.389,2.389,0,0,0,.623,1.8,1.188,1.188,0,0,1,.291.71v.084a1.188,1.188,0,0,1-.291.71,1,1,0,0,1-.748.292h-.208a9.876,9.876,0,0,1-9.763-10.022,10.062,10.062,0,0,1,2.95-7.015,9.6,9.6,0,0,1,7.021-2.839H24.4c5.235.209,9.43,4.05,9.43,8.727A5.557,5.557,0,0,1,32.294,27.563Z",
    transform: "translate(-12.39 -13.7)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1336",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_123",
    "data-name": "Trac\\xE9 123",
    d: "M23.943,13.7h-.415a11.382,11.382,0,0,0-7.686,19.542A11.126,11.126,0,0,0,23.9,36.416h0a2.506,2.506,0,0,0,2.493-2.505,2.668,2.668,0,0,0-.623-1.67,1.027,1.027,0,0,1-.249-.668,1.041,1.041,0,0,1,1.039-1.086h2.077a6.613,6.613,0,0,0,6.605-6.639C35.243,18.293,30.175,13.7,23.943,13.7Zm8.35,13.863a5.174,5.174,0,0,1-3.656,1.5H26.561a2.424,2.424,0,0,0-1.662.626,2.5,2.5,0,0,0-.831,1.712,2.389,2.389,0,0,0,.623,1.8,1.188,1.188,0,0,1,.291.71v.084a1.188,1.188,0,0,1-.291.71,1,1,0,0,1-.748.292h-.208a9.876,9.876,0,0,1-9.763-10.022,10.062,10.062,0,0,1,2.95-7.015,9.6,9.6,0,0,1,7.021-2.839H24.4c5.235.209,9.43,4.05,9.43,8.727A5.557,5.557,0,0,1,32.294,27.563Z",
    transform: "translate(-12.39 -13.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    transform: "translate(3.785 9.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_124",
    "data-name": "Trac\\xE9 124",
    d: "M24.242,37.569a1.3,1.3,0,0,1-1.371,1.169A1.273,1.273,0,0,1,21.5,37.569,1.3,1.3,0,0,1,22.871,36.4,1.273,1.273,0,0,1,24.242,37.569Z",
    transform: "translate(-21.5 -36.4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    transform: "translate(7.441 4.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125",
    "data-name": "Trac\\xE9 125",
    d: "M33.042,26.678A1.371,1.371,0,1,1,31.671,25.3,1.387,1.387,0,0,1,33.042,26.678Z",
    transform: "translate(-30.3 -25.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    transform: "translate(13.007 4.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_126",
    "data-name": "Trac\\xE9 126",
    d: "M46.442,26.678A1.371,1.371,0,1,1,45.071,25.3,1.387,1.387,0,0,1,46.442,26.678Z",
    transform: "translate(-43.7 -25.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    transform: "translate(16.622 9.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_127",
    "data-name": "Trac\\xE9 127",
    d: "M54.726,37.569A1.163,1.163,0,1,1,53.563,36.4,1.139,1.139,0,0,1,54.726,37.569Z",
    transform: "translate(-52.4 -36.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.3e315301b91f4957aa8ffd04d9596305.svg";
export { ForwardRef as ReactComponent };